import { cn } from "@repo/utils";

type Props = {
  children: React.ReactNode;
  className?: string;
};

export const PageLayout = ({ children, className }: Props) => {
  return <div className={cn("flex min-h-screen w-full flex-col", className)}>{children}</div>;
};
